declare var $: any

export const notificationIconMap = {
  success: "ti-check",
  warning: "ti-alert",
}

export type NotificationDismissValue = "overlay" | "cancel" | "close" | "esc"

export function showNotification(message: string, type: string = "success"): void {
  $.notify(
    {
      icon: notificationIconMap[type],
      message,
    },
    {
      type,
      timer: 2000,
      placement: {
        from: "top",
        align: "center",
      },
    },
  )
}
